import React, { useState } from "react";
import {
  TextField,
  Button,
  Alert,
  Stack,
  Link as MuiLink,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ClientPortalShell from "./ClientPortalShell";
import { getClientPortalErrorMessage } from "./clientPortalErrorMessage";
import {
  portalLogin,
  setClientPortalSession,
} from "../../api/clientPortal";

const COMPANY_RE = /^[a-zA-Z0-9._-]{2,32}$/;

export default function ClientPortalLoginPage() {
  const [params] = useSearchParams();
  const company = String(params.get("company") || "").trim().toLowerCase();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const companyValid = COMPANY_RE.test(company);
  const q = company ? `?company=${encodeURIComponent(company)}` : "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!companyValid) {
      setError(
        "O endereço de acesso está incompleto. Use o link completo enviado pela empresa."
      );
      return;
    }
    setBusy(true);
    setError(null);
    try {
      const res = await portalLogin({ email: email.trim(), password, company });
      setClientPortalSession({ token: res.token, company });
      navigate(`/portal-cliente/app${q}`);
    } catch (err) {
      setError(getClientPortalErrorMessage(err, { context: "login" }));
    } finally {
      setBusy(false);
    }
  };

  return (
    <ClientPortalShell
      title="Portal do Cliente"
      subtitle="Acompanhe suas solicitações e abra novas quando precisar"
    >
      {!companyValid && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Acesse pelo link completo enviado pela empresa. Se recebeu apenas o site, peça o endereço correto ao suporte.
        </Alert>
      )}

      <Stack component="form" spacing={2} onSubmit={handleSubmit}>
        <TextField
          label="E-mail"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          fullWidth
          autoComplete="email"
        />
        <TextField
          label="Senha"
          type={showPwd ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          fullWidth
          autoComplete="current-password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPwd((v) => !v)} edge="end" aria-label="mostrar senha">
                  {showPwd ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {error && <Alert severity="error">{error}</Alert>}

        <Button type="submit" variant="contained" size="large" disabled={busy || !companyValid}>
          {busy ? "Entrando…" : "Entrar"}
        </Button>

        <MuiLink component={Link} to={`/portal-cliente/forgot-password${q}`} variant="body2" align="center">
          Esqueci minha senha
        </MuiLink>
      </Stack>
    </ClientPortalShell>
  );
}
